import { render, staticRenderFns } from "./DNSTwisterSearchResults.vue?vue&type=template&id=17ae427c&"
import script from "./DNSTwisterSearchResults.vue?vue&type=script&lang=js&"
export * from "./DNSTwisterSearchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports